import React from 'react';
import styles from './Edition2Page.module.css';

const speakers = [
  {
    nom: 'Emir Belkahia',
    titre: 'Strategic Customer Success Manager / ALGOLIA',
    image: 'https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/692f590441e3a8ce3b3295b6_Blanc%20Photographique%20e%CC%81le%CC%81gant%20Post%20Instagram%20(12).png',
    linkedin: 'https://www.linkedin.com/in/emirbelkahia/',
  },
  {
    nom: 'Benjamin Boyer',
    titre: 'E-Commerce B2C/B2B/OMS / SALESFORCE',
    image: 'https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/692d426d2d63e5ea6d0ec876_6.png',
    linkedin: 'https://www.linkedin.com/in/benjaboyer/',
  },
  {
    nom: 'Amal Dopchie',
    titre: 'Practice manager Digital Commerce/Omnichannel',
    image: 'https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/692d436a6bc89f793f10913a_Blanc%20Photographique%20e%CC%81le%CC%81gant%20Post%20Instagram%20(6).png',
    linkedin: 'https://www.linkedin.com/in/amaldopchie/',
  },
  {
    nom: 'Cyrille Groult',
    titre: 'Sales Director / SESA SYSTEMS',
    image: 'https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/6931bd47819112943c1d76f9_Blanc%20Photographique%20e%CC%81le%CC%81gant%20Post%20Instagram%20(14).png',
    linkedin: 'https://www.linkedin.com/in/cyrille-groult-304901139/',
  },
  {
    nom: 'Soumaya Hamzaoui',
    titre: 'CPO/CCO / REDCLOUD',
    image: 'https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/692fe549cbcbd49c846b1511_Blanc%20Photographique%20e%CC%81le%CC%81gant%20Post%20Instagram%20(13).png',
    linkedin: 'https://www.linkedin.com/in/soumayahamzaoui/',
  },
  {
    nom: 'Amélie Maréchal',
    titre: 'Consultante e-commerce & digital, En mission chez ARKEMA',
    image: 'https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/692d46bb772129e4247cb102_Blanc%20Photographique%20e%CC%81le%CC%81gant%20Post%20Instagram%20(9).png',
    linkedin: 'https://www.linkedin.com/in/ameliemarechal/',
  },
  {
    nom: 'Rudy Abitbol',
    titre: 'Expert B2B / RudyAbitbol.com',
    image: 'https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/69343efd7426887369b80b6d_Blanc%20Photographique%20e%CC%81le%CC%81gant%20Post%20Instagram%20(16).png',
    linkedin: 'https://www.linkedin.com/in/rudyabitbol/',
  },
  {
    nom: 'Yohan Grillot',
    titre: 'Directeur Général / SESA SYSTEMS',
    image: 'https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/6935d9a02b192c4ce8ac02a6_Blanc%20Photographique%20e%CC%81le%CC%81gant%20Post%20Instagram%20(17).png',
    linkedin: 'https://www.linkedin.com/in/yohan-grillot-sesa-systems-lean-enterprise/',
  },
];

const Edition2Page: React.FC = () => {
  return (
    <>
      {/* Hero — image background with dark overlay */}
      <section className={styles.heroImageBg}>
        <div className={styles.heroContainer}>
          <h1 className={styles.heroBrands2Buyers}>BRANDS2BUYERS</h1>
          <div className={styles.heroEdition}>Édition 2</div>
        </div>
      </section>

      {/* Description — fond blanc */}
      <section className={styles.heroDescSection}>
        <div className={styles.heroDescContainer}>
          <h1 className={styles.heroTitle}>Bienvenue à Brands2Buyers édition 2 !</h1>
          <div className={styles.heroDesc}>
            Une soirée dédiée aux échanges directs, aux retours d'expérience concrets et aux
            meilleures pratiques pour fluidifier les collaborations B2B.
          </div>
        </div>
      </section>

      {/* Programme — fond jaune */}
      <section className={styles.programmeSection}>
        <div className={styles.programmeSectionInner}>
          <h1 className={styles.sectionTitle}>AU PROGRAMME</h1>

          <div className={styles.programmeText}>
            <span className={styles.heureBlue}>18H00 </span>— <span className={styles.eventName}>ON LANCE LES HOSTILITÉS !</span><br />
            La soirée démarre en beauté avec des cocktails de folie. C'est le moment de briser la glace !<br /><br />

            <span className={styles.heureBlue}>18H30 : </span><span className={styles.eventName}>début de la conférence</span><br />
            Introduction et objectifs de l'évènement.<br /><br />

            <span className={styles.heureBlue}>18H45 : </span><span className={styles.eventName}>Keynote d'ouverture</span><br />
            <span className={styles.intervenants}><strong>Laetitia Lamari, Adrien Naeem &amp; Rudy Abitbol</strong></span><br />
            Rétrospective 2025 et projections 2026<br /><br />

            <span className={styles.heureBlue}>19H00 : </span><span className={styles.eventName}>TABLE RONDE 1</span><br />
            <span className={styles.intervenants}><strong>Emir Elkahia, Amélie Maréchal &amp; Amal Dopchie</strong></span><br />
            Du B2B complexe à l'IA agentique : comment moderniser l'expérience digitale ?<br /><br />

            <span className={styles.heureBlue}>19H30 : </span><span className={styles.eventName}>TABLE RONDE 2</span><br />
            <span className={styles.intervenants}><strong>Benjamin Boyer &amp; Soumaya Hamzaoui</strong></span><br />
            Agilité, intégrations et scalabilité : comment transformer une organisation B2B ?<br /><br />

            <span className={styles.heureBlue}>20H00 : </span><span className={styles.eventName}>FIRESIDE CHAT</span><br />
            <span className={styles.intervenants}><strong>Yohan Grillot &amp; Cyrille Groult</strong></span><br />
            Digitalisation, valeur ajoutée et usine du futur chez SESA Systems.<br /><br />

            <span className={styles.heureBlue}>20H30 </span>— <span className={styles.eventName}>LE MOMENT NETWORKING</span><br />
            Cocktails et connexions stratégiques... La soirée devient carrément légendaire !
          </div>
        </div>
      </section>

      {/* Speakers — fond blanc, layout 2 colonnes */}
      <section className={styles.speakersSection}>
        <div className={styles.speakersSectionInner}>
          {/* Colonne gauche : illustration d'ambiance */}
          <div className={styles.speakersLeftCol}>
            <img
              src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67101d4ea219e41ad2af2784_AlbedoBase_XL_90s_style_2_men_talk_on_stage_in_front_of_an_aud_3.jpg"
              alt="Ambiance événement B2B"
              className={styles.speakersIllustration}
            />
          </div>
          {/* Colonne droite : titre + grille speakers */}
          <div className={styles.speakersRightCol}>
            <h2 className={styles.speakersH2}>DES INVITÉS B2B AMBITIEUX :</h2>
            <div className={styles.speakersGrid}>
              {speakers.map((speaker, index) => (
                <div key={index} className={styles.speakerCard}>
                  <a href={speaker.linkedin} target="_blank" rel="noreferrer">
                    <div className={styles.speakerImageWrapper}>
                      <img
                        src={speaker.image}
                        alt={speaker.nom}
                        className={styles.speakerImage}
                        loading="lazy"
                      />
                    </div>
                  </a>
                  <div className={styles.speakerInfo}>
                    <p className={styles.speakerNom}><strong>{speaker.nom}</strong></p>
                    <p className={styles.speakerTitre}><strong>{speaker.titre}</strong></p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp — fond violet-b2b */}
      <section className={styles.whatsappSection}>
        <div className={styles.whatsappInner}>
          <div className={styles.whatsappTextBlock}>
            <h1 className={styles.whatsappTitle}>Rejoignez le groupe WhatsApp Brands2Buyers !</h1>
            <div className={styles.whatsappText}>
              Un espace réservé aux participants pour :<br />
              • partager vos actualités et vos besoins<br />
              • rester en contact avec les marques et partenaires présents<br />
              • retrouver les ressources et informations clés de l'évènement<br />
              • être informé(e) en avant-première des prochaines éditions.
            </div>
            <a
              href="https://chat.whatsapp.com/KN6a2NAqGUB6pHnjqvFqin"
              target="_blank"
              rel="noreferrer"
              className={styles.whatsappBtn}
            >
              Rejoindre le groupe !
            </a>
          </div>
          <div className={styles.whatsappImage}>
            <img
              src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/670f9cc9a04d7cedcfa9e171_AlbedoBase_XL_90s_mobile_social_media_0.jpg"
              loading="lazy"
              alt="WhatsApp"
            />
          </div>
        </div>
      </section>

      {/* Section Noël — fond jaune, unique à cette page */}
      <section className={styles.noelSection}>
        <div className={styles.noelInner}>
          <h1 className={styles.noelTitle}>Retrouvez-nous pour fêter Noël !</h1>
          <img
            src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/6934556cb5c43e3aa002d6de_Bannie%CC%80res%20events%20LI%20(10).png"
            alt="Fêter Noël avec Brands2Buyers"
            className={styles.noelImage}
            loading="lazy"
          />
          <a
            href="https://www.linkedin.com/events/7368403282806861825/"
            target="_blank"
            rel="noreferrer"
            className={styles.noelBtn}
          >
            Infos et inscriptions
          </a>
        </div>
      </section>

      {/* Communauté — fond rose-b2b */}
      <section className={styles.communauteSection}>
        <div className={styles.communauteInner}>
          <h1 className={styles.communauteTitle}>Rejoignez la communauté !</h1>
          <div className={styles.communauteText}>
            Nous avons secoué l'e-commerce et fédéré une vraie tribu : une communauté de milliers
            de passionnés qui suivent chaque jour l'e-commerce qui bouge. Rejoignez nos groupes
            pour papoter tendances, partager vos galères, vos victoires… et ne plus jamais
            brainstormer tout seul !
          </div>
          <div className={styles.communauteImages}>
            <a href="https://chat.whatsapp.com/K0EV7FJH29BEMYxQFgO9e3" target="_blank" rel="noreferrer">
              <img
                src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/693458f4c9ec48264e94ebe7_684bea8c000512a9d85c56d3_1.jpg"
                loading="lazy"
                alt="Communauté WhatsApp 1"
              />
            </a>
            <a href="https://chat.whatsapp.com/IrSzW75IfsUFIAKnTbGYPA" target="_blank" rel="noreferrer">
              <img
                src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/693458f48b0d508ece27359e_684bea8c4604b4f162f6185c_2.jpg"
                loading="lazy"
                alt="Communauté WhatsApp 2"
              />
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Edition2Page;
